<template>
    <Datetime
      ref="control"
      class="main"
      :class="disabled ? 'disabled' : ''"
      :disabled="disabled"

      :timeUse="false"

      :value="value"
      @input="$emit( 'input', $event )"

      data-focus="1"
      @ok="$emit( 'ok', $event )"

      @error="$emit( 'error', $event )"
    />
</template>

<script>
import Datetime from "./Datetime"

export default {
	name:  "DVfieldDate",

	components: {
    Datetime
	},

  props: {
		disabled: {
			type: Boolean,
			default: false,
		},
    value: {
		  type: String,
      default: false
    }
	},
	data() {
		return {
		};
	},
  methods: {
	  update( ...args ) {
	    if ( this.$refs && this.$refs.control && this.$refs.control.update ) this.$refs.control.update( ...args );
    }
	},
  computed: {
  }
};
</script>

<style scoped>
  .main {
    background-color: #FFFFFF;
  }
  .disabled {
    background-color: rgba( 255, 255, 255, 0.5 );
  }
</style>